import React from 'react';
import PropTypes from 'prop-types';
import { HeaderWrapper, Header } from './styled';

/**
 * SingleHeader
 * @param header {string}{required}
 * @returns {JSX.Element}
 */
const SingleHeader = ({ header }) => (
  <HeaderWrapper>
    <Header>{header}</Header>
  </HeaderWrapper>
);

SingleHeader.propTypes = {
  header: PropTypes.string.isRequired
};

export default SingleHeader;
